(() => {
  const OPEN_DELAY = 150;
  const triggers = document.querySelectorAll('.header [data-meganav-trigger], .header [data-dropdown-trigger]');

  let timer = null;
  let pending = null;

  const fire = (el) => {
    el.__cbPass = true;
    el.dispatchEvent(new MouseEvent('mouseover', { bubbles: true, cancelable: true, view: window }));
    el.__cbPass = false;
  };

  // Hold the theme's instant open until the pointer rests on the item.
  window.addEventListener('mouseover', (e) => {
    const el = e.target.closest && e.target.closest('[data-meganav-trigger], [data-dropdown-trigger]');
    if (!el || !el.closest('.header') || el.__cbPass) return;
    if (el.getAttribute('aria-expanded') === 'true') return;
    e.stopImmediatePropagation();
    if (pending === el) return;
    clearTimeout(timer);
    pending = el;
    const anyOpen = document.querySelector('.header.dropdown-active');
    timer = setTimeout(() => { pending = null; fire(el); }, anyOpen ? 60 : OPEN_DELAY);
  }, true);

  triggers.forEach((el) => {
    el.addEventListener('mouseleave', () => {
      if (pending === el) { clearTimeout(timer); pending = null; }
    });
  });

  // Load card images the first time a panel opens.
  const loadImages = (panel) => {
    if (panel.__cbLoaded) return;
    panel.__cbLoaded = true;
    panel.querySelectorAll('img[data-src]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  };

  const drawerMenu = document.querySelector('[data-drawer-menu]');
  if (drawerMenu) {
    new MutationObserver(() => {
      if (document.body.getAttribute('mobile-menu-open') === 'true') loadImages(drawerMenu);
    }).observe(document.body, { attributes: true, attributeFilter: ['mobile-menu-open'] });
  }

  document.querySelectorAll('[data-cb-mm]').forEach((panel) => {
    new MutationObserver(() => {
      if (panel.classList.contains('active')) loadImages(panel);
      else show(panel, 'default');
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });

    let swap = null;
    panel.querySelectorAll('[data-cb-mm-key]').forEach((link) => {
      const go = () => { clearTimeout(swap); swap = setTimeout(() => show(panel, link.dataset.cbMmKey, link), 80); };
      link.addEventListener('mouseenter', go);
      link.addEventListener('focus', go);
    });
  });

  function show(panel, key, link) {
    const target = panel.querySelector('[data-cb-mm-set="' + key + '"]') || panel.querySelector('[data-cb-mm-set="default"]');
    if (!target) return;
    panel.querySelectorAll('[data-cb-mm-set]').forEach((s) => {
      const on = s === target;
      s.hidden = !on;
      s.classList.toggle('is-active', on);
    });
    panel.querySelectorAll('.cb-mm__link').forEach((a) => a.classList.toggle('is-current', a === link));
  }
})();
